module.exports = __webpack_public_path__ + "PW.png?e1f02487b3e53d7e48072902b4a04b43";